import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		filters: {
			query: '',
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH EVENT_LIVE_PACKETS_ASSIGNED ***************
			case types.FETCH_EVENT_LIVE_PACKETS_ASSIGNED_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_EVENT_LIVE_PACKETS_ASSIGNED_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				return;

			case types.FETCH_EVENT_LIVE_PACKETS_ASSIGNED_PAYMENT_MODEL_TYPE_ERROR:
				return { ...INITIAL_STATE, loading: false };

			case types.FETCH_EVENT_LIVE_PACKETS_ASSIGNED_ERROR:
				draft.error = action.payload;
				return;

			// *************** SET SEARCH QUERY ***************
			case types.SET_EVENT_LIVE_PACKETS_ASSIGNED_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				return;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
